import React from "react";

export default function ServiceModel({hoverModalDisplay}) {
  return (<div id="fedramp-serviceModelBox" className={`fedramp-serviceModelBoxClass fedramp-hoverBox${hoverModalDisplay}`}>
    <strong>Service Model:</strong>
    <br/><br/>
    The type of cloud service:
    <br/>
    <ul>
      <li><strong>IaaS:</strong> Infrastructure as a Service</li>
      <li><strong>PaaS:</strong> Platform as a Service</li>
      <li><strong>SaaS:</strong> Software as a Service</li>
      <li>a combination (i.e., PaaS & SaaS or IaaS & PaaS)</li>
    </ul>
  </div>);
}